import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import { useLocation } from "react-router-dom";
import routesData from "../shared/routes.json";

import {
  CompleteAadhaarAPICall,
  digiLockerAuthenticationAPICall,
} from "../shared/APICalls";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Redirect.module.scss";
import { REDIRECTURL } from "../shared/constants";

export default function SuccessPage() {
  const [countDown, setCountDown] = useState(3);
  const [loading, setloading] = useState(false);
  const navigationData = routesData;
  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const setu_id = params.code;
  const state = params.state;

  // const shareCode = params.shareCode;
   console.log("params",params);
  //  console.log(pathName)
  sessionStorage.setItem("access-token", state);

  useEffect(() => {
    sendDetails();
  }, []);

  function sendDetails() {
    let obj: any = {
      code: setu_id,
    };
    setloading(true);
    digiLockerAuthenticationAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        CompleteAadhaarStage();
      })
      .catch((error: any) => {
        setloading(false);
        window.location.href = `${REDIRECTURL}panverification`;
      });
  }

  const CompleteAadhaarStage = () => {
    CompleteAadhaarAPICall()
      .then((response: any) => {
        setloading(false);
        setTimeout(() => {
          // window.location.href = `${REDIRECTURL}yourprofile`;
          if (
            response.data.data.next_stage &&
            navigationData.hasOwnProperty(response.data.data.next_stage)
          ) {
            window.location.href =
              navigationData[response.data.data.next_stage];
          }
        }, 3000);
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountDown((prevCountDown) => prevCountDown - 1);
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (countDown < 0) {
      setCountDown(5);
    }
  }, [countDown]);

  return (
    <>
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : "We have obtained your documents"}{" "}
              </p>
              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : `You will be redirected in ${countDown} seconds.`}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
